type MessageTextProps = {
  text: string;
  className?: string;
};

/** Plain message text with emoji-friendly font stack (Unicode + system emoji fonts). */
export function MessageText({ text, className }: MessageTextProps) {
  const classes = ['teo-bubble__text', 'teo-emoji-text', className]
    .filter(Boolean)
    .join(' ');

  return <div className={classes}>{text}</div>;
}
